module.exports = __webpack_public_path__ + "img/body-1.88b6daf0.png";